export default function humanize(str) {
  const newStr = str.replace(/_/g, ' ');
  return (newStr[0].toUpperCase() + newStr.substring(1));
}
